import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { resources } from "./resources";
import Storage from "store";

export const DEFAULT_LANGUAGE = "en";
export const systemLanguageKey = {
  en: "en",
  "zh-CN": "zh-Hans",
  "zh-TW": "zh-Hans-F",
  "vi-VN": "vi",
  vi: "vi",
  id: "id",
};

// 系统默认语言
const defaultSystemLanguage = systemLanguageKey[navigator.language];
// 获取上一次语种设定值
const storeLanguage = Storage.get("language");

const hasLanguageKey = (k) => Object.values(systemLanguageKey).includes(k);

// 从本地存储中获取语言设置
export const defaultLanguage = hasLanguageKey(storeLanguage)
  ? storeLanguage
  : hasLanguageKey(defaultSystemLanguage)
  ? defaultSystemLanguage
  : DEFAULT_LANGUAGE;

// 加载国际化配置
export const i18nInit = () =>
  i18n.use(initReactI18next).init({
    resources,
    lng: defaultLanguage,
  });

export * from "./resources";
